import _ from "lodash";
import * as React from "react";
import Categories from "./Categories";
import NewsFeed from "./NewsFeed";
import Tags from "./Tags";

interface IProps {
    settings: any;
    categories: any[];
    tags: any[];
    feed: any;
}

const Filter = (props: IProps) => {
    return !_.isEmpty(props.categories) || !_.isEmpty(props.tags) || (props.feed !== undefined && !_.isEmpty(props.feed?.feedName)) ? <div className="CMS_subsection">
        <div className="CMS_e_row">
            {props.feed !== undefined && !_.isEmpty(props.feed.feedName) && props.settings !== undefined && props.settings.ShowFeedName ? <NewsFeed newsfeed={props.feed.feedName} /> : null}
            <Categories categories={props.categories} />
            <Tags tags={props.tags} />
        </div>
    </div> : null;
};

export default Filter;
